interface ContactProps {
  onGetStarted: () => void;
}

export default function Contact({ onGetStarted }: ContactProps) {
  return (
    <section id="contact" className="py-12 sm:py-20 bg-[#1a1a1a] font-body">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-8 sm:mb-12">
          <div className="flex items-center justify-center gap-3 mb-4">
            <div className="w-8 h-[1px] bg-[#F5C518]"></div>
            <span className="text-[#F5C518] text-xs font-semibold tracking-[0.3em] uppercase">Contact</span>
            <div className="w-8 h-[1px] bg-[#F5C518]"></div>
          </div>
          <h2 className="text-4xl sm:text-6xl md:text-7xl font-display tracking-wide text-white">LET&apos;S WORK TOGETHER</h2>
          <p className="text-white/40 text-sm sm:text-base leading-relaxed max-w-2xl mx-auto mt-5">
            Ready to bring your vision to life? Reach out and let&apos;s get started on building your strategic online presence.
          </p>
        </div>

        <div className="max-w-xl mx-auto">
          <div className="bg-white/5 backdrop-blur-sm rounded-lg p-8 sm:p-10 border border-white/10 hover:border-[#F5C518]/30 transition-all">
            <div className="w-11 h-11 bg-[#F5C518] rounded-md flex items-center justify-center mb-5">
              <i className="ri-message-3-line text-xl text-[#1a1a1a]"></i>
            </div>
            <h3 className="text-2xl sm:text-3xl text-white mb-4 font-display tracking-wide">GET IN TOUCH</h3>
            <p className="text-white/50 mb-8 leading-relaxed text-sm">
              Fill out an inquiry form or send me an email directly. I&apos;ll get back to you as soon as possible to discuss your project.
            </p>

            <div className="flex flex-col sm:flex-row gap-3">
              <button
                onClick={onGetStarted}
                className="flex-1 bg-[#F5C518] text-[#1a1a1a] px-6 py-3.5 rounded-md text-[13px] font-semibold tracking-[0.1em] uppercase hover:bg-[#D4A90E] transition-all cursor-pointer whitespace-nowrap shadow-lg shadow-[#F5C518]/20 hover:shadow-xl hover:-translate-y-0.5 flex items-center justify-center gap-2"
              >
                Get Started
                <i className="ri-arrow-right-up-line"></i>
              </button>
              <a
                href="mailto:yasminetheceo@gmail.com"
                className="flex-1 border border-white/15 hover:border-white/40 text-white/60 hover:text-white px-6 py-3.5 rounded-md text-[13px] font-semibold tracking-[0.1em] uppercase transition-all cursor-pointer whitespace-nowrap hover:-translate-y-0.5 flex items-center justify-center gap-2"
              >
                <i className="ri-mail-line"></i>
                Email Me
              </a>
            </div>

            <div className="mt-8 pt-6 border-t border-white/10 flex items-center justify-center gap-8">
              <div className="flex items-center gap-3">
                <div className="w-8 h-8 flex items-center justify-center rounded bg-white/5">
                  <i className="ri-chat-smile-3-line text-[#F5C518] text-sm"></i>
                </div>
                <span className="text-white/40 text-xs">Quick Response</span>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-8 h-8 flex items-center justify-center rounded bg-white/5">
                  <i className="ri-hand-heart-line text-[#F5C518] text-sm"></i>
                </div>
                <span className="text-white/40 text-xs">Friendly Service</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
